<template lang="html">

  <section class="banner-premio row-center animation" id="banner-premios" :style="`background:url('/static/img/productos/${data}/banner-premio.jpg')`">
    <div class="container textos row-between">

      <h2 class="title -ghost" v-html="$t(`productos.${data}.banner_premios.titulo`)"></h2>   

      <div class="premio row-center">

        <div class="contenedor-imagen">
          <img :src="'/static/img/productos/'+data+'/premios/'+$t(`productos.${data}.banner_premios.premio`)+'.png'" alt="">
        </div>

        <div class="premio-info">
          <p>
            <strong>
              {{$t(`productos.${data}.premios.premios['${$t(`productos.${data}.banner_premios.premio`)}'].titulo`)}} - 
              {{$t(`productos.${data}.premios.premios['${$t(`productos.${data}.banner_premios.premio`)}'].anyo`)}}
            </strong>
          </p>
          <p>{{$t(`productos.${data}.premios.premios['${$t(`productos.${data}.banner_premios.premio`)}'].texto`)}}</p>
        </div>

        
        
      </div>   
      
      <router-link :to="`${$t('enlaces.productos')}/${this.$route.params.id}${$t('enlaces.premios')}`" class="btn">
        <span>{{$t(`productos.${data}.banner_premios.boton`)}}</span>
      </router-link>

    </div>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'banner-premio',
    props:['data']
  }
</script>

<style scoped lang="scss">
  .banner-premio {

    .textos{
      padding: 50px 0;
      height: 390px;
      position: relative;
      -webkit-flex-wrap: nowrap;
      -moz-flex-wrap: nowrap;
      -ms-flex-wrap: nowrap;
      -o-flex-wrap: nowrap;
      flex-wrap: nowrap;
    }

    .-ghost{
      position: absolute;
      top: -64px;
      z-index: 5;
    }

    .premio{
      max-width: calc(100% - 350px);

      .contenedor-imagen{
        width: 200px;
        height: 200px;
        transform: translateY(300px);
        opacity: 0;
        transition: .8s;
        img{
          max-width: 100%;
          max-height: 100%;
          display: inline-block;
        }
      }

      .premio-info{
        padding: 0 100px;
        max-width: calc(100% - 250px);
        p{
          transform: translateY(300px);
          opacity: 0;
          transition: .8s;
          transition-delay: .3s;
        }

        p:last-of-type{
         transition-delay: .7s; 
       }
     }
   }

   .btn{
    transform: translateY(300px);
    opacity: 0;
    transition: .8s;
    transition-delay: 1s;
  }

  &.launched{
    .contenedor-imagen,
    .premio-info p,
    .btn{
      opacity: 1;
      transform: translateY(0);
    }
  }
}

@media screen and (max-height: 1200px){

  .banner-premio .textos{
    height: auto;
    -webkit-flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -o-flex-direction: column;
    flex-direction: column;

    .premio{
      max-width: 100%;
    }

    .premio-info{
      padding: 0 50px;
    }
  }
  
}


@media screen and (max-width: 700px){

  .banner-premio .textos{
    
    padding: 25px 0;

    .premio{
      max-width: 100%;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;

      .contenedor-imagen{
        width: 150px;
        height: 150px;
      }
    }


    .-ghost{
      top: -26px;
      left: 10px;
    }

    .premio-info{
      padding: 0 15px;
      max-width: 100%;
      margin-bottom: 20px;

      p{
        text-align: center;
      }
    }
  }
  
}

</style>



// WEBPACK FOOTER //
// src/components/views/productos/banner-premio.vue